module.exports = function(){



    var addItemToWishlistCookie = Cookies.get('ADD_TO_WISHLIST_AFTER_LOGIN');
    if (addItemToWishlistCookie && window.globalCustomerId) {
        eph.addItemToWishlist(addItemToWishlistCookie);
        Cookies.remove('ADD_TO_WISHLIST_AFTER_LOGIN');
    }







    //https://eph-wa.d3.dashagencydev.com/api/v1/wa-customers/wa_customer_id/addToWishlist/wa_web_product_id

    if ( $('.js-wishlist-products-container').length ) {

        var itemTemplate = require('../templates/wishlist-item.hbs');
        var container = $('.js-wishlist-products-container');
        //$(globalWishlistProductsIdArray).each(function(index, el) {
        //});

        var renderItems = function(itemsArray){
            var itemTemplate = require('../templates/wishlist-item.hbs');
            var container = $('.js-wishlist-products-container');

            //var allItems = lsWishlist.getAllItems();


            if (! Object.keys(itemsArray).length) {
                container.find('.js-loading-wishlist-info').remove();

                container.append('<div class="block--intro block--center block--large"><h2>You haven\'t added anything to your wishlist yet.</h2></div>');

            } else {

                itemsArray.forEach( function(element, index) {
                    window.eph.getSingleProduct(element.WaWebProductId, false, false, null, function(templateData){
                        container.find('.js-loading-wishlist-info').remove();
                        container.append( itemTemplate(templateData) );
                    });
                });

            }


        };


        eph.getUserWishlist({
            success: function(data, textStatus, jqXHR){
                renderItems(data);
            },
        });










    }




    $(document).on('click', '.js-wishlist-item-remove', function(event) {
        event.preventDefault();

        var productEl = $(this).closest('.js-wishlist-product');
        var productId = productEl.attr('data-prod-id');

        window.eph.deleteItemFromWishlist(productId, function(){
            productEl.remove();

            new jBox('Notice', {
                content: 'Product Deleted From Wishlist',
                attributes: {
                    x: 'right',
                    y: 'bottom'
                },
            });


        });

    });



    $('.js-wishlist-add').on('click', function(event) {
        event.preventDefault();
        var self = this;
        var productId = $(this).attr('data-prod-id');
        $(self).text('Adding to wishlist...');
        $(self).prop('disabled', true);
        eph.addItemToWishlist(productId, function(){
            //new jBox('Notice', {
            //    content: 'Product Added To Wishlist',
            //    attributes: {
            //        x: 'right',
            //        y: 'bottom'
            //    },
            //});
            $(self).text('Added to wishlist');
            $(self).prop('disabled', true);
        }, function(){
            $(self).text('Error while adding to wishlist... Try again.');
            $(self).prop('disabled', false);
            //new jBox('Notice', {
            //    content: 'There was some error while adding this product to wishlist: ' + jqXHR.responseJSON.msg,
            //    attributes: {
            //        x: 'right',
            //        y: 'bottom'
            //    },
            //});
        });
    });





    $('.js-wishlist-add-later').on('click', function(event) {
        event.preventDefault();
        var productId = $(this).attr('data-prod-id');
        Cookies.set('ADD_TO_WISHLIST_AFTER_LOGIN', productId);
    });








    //$(document).on('click', '.js-wishlist-item-remove', function(event) {
    //    event.preventDefault();
    //    var id = $(this).closest('.js-wishlist-product').attr('data-prod-id');
    //    //lsWishlist.remove(id);
    //});







}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/wishlist.js